import i18next from "i18next";
import PropTypes from "prop-types";

const timeslotShape = PropTypes.shape({
    slot: PropTypes.string,
    validTill: PropTypes.string,
    isToday: PropTypes.bool,
});

export const CreateGroupOrderPropTypes = {
    labels: PropTypes.shape({
        title: PropTypes.string,
        subtitle: PropTypes.string,
        enterName: PropTypes.string,
        whereToDeliver: PropTypes.string,
        pickup: PropTypes.string,
        delivery: PropTypes.string,
        whenToDelivery: PropTypes.string,
        whenToPickup: PropTypes.string,
        pickStoreForPickup: PropTypes.string,
        earliestPossible: PropTypes.string,
        orderLatestTo: PropTypes.string,
        selectDeliverySlot: PropTypes.string,
        pickTimeslot: PropTypes.string,
        orderAsGroupCTA: PropTypes.string,
        orderTogetherTitle: PropTypes.string,
        orderTogetherSubtitle: PropTypes.string,
        orderTogetherDisclaimer: PropTypes.string,
        linkTitle: PropTypes.string,
        linkSubtitle: PropTypes.string,
        groupOrderTip: PropTypes.string,
        orderTill: PropTypes.string,
        groupOrderWarning: PropTypes.string,
        finish: PropTypes.string,
        qrcode: PropTypes.string,
        linkCopied: PropTypes.string,
        shareLink: PropTypes.string,
        abort: PropTypes.string,
    }),
    heroImageSrc: PropTypes.string,
    name: PropTypes.string,
    setName: PropTypes.func,
    location: PropTypes.string,
    isPickup: PropTypes.bool,
    timeslot: timeslotShape,
    isEarliestTimeslot: PropTypes.bool,
    onBackClick: PropTypes.func,
    step: PropTypes.oneOf(["INFO", "SHARE"]),
    onDeliveryToggle: PropTypes.func,
    earliestPossibleTimeslot: timeslotShape,
    selectEarliestTimeslot: PropTypes.func,
    formErrors: PropTypes.object,
    submitGroupOrder: PropTypes.func,
    openQrCode: PropTypes.func,
    groupOrderUrl: PropTypes.string,
    copyGroupOrderUrl: PropTypes.func,
    mobileShouldHide: PropTypes.bool,
    earlyOnLocationText: PropTypes.string,
    isSubmitting: PropTypes.bool,
};

export const CreateGroupOrderLabels = {
    title: i18next.t("createGroupOrder.title"),
    subtitle: i18next.t("createGroupOrder.subtitle"),
    enterName: i18next.t("createGroupOrder.enterName"),
    whereToDeliver: i18next.t("createGroupOrder.whereToDeliver"),
    pickup: i18next.t("createGroupOrder.pickup"),
    delivery: i18next.t("createGroupOrder.delivery"),
    whenToPickup: i18next.t("createGroupOrder.whenToPickup"),
    whenToDelivery: i18next.t("createGroupOrder.whenToDelivery"),
    pickStoreForPickup: i18next.t("createGroupOrder.pickStoreForPickup"),
    earliestPossible: i18next.t("createGroupOrder.earliestPossible"),
    orderLatestTo: i18next.t("createGroupOrder.orderLatestTo"),
    selectDeliverySlot: i18next.t("createGroupOrder.selectDeliverySlot"),
    pickTimeslot: i18next.t("createGroupOrder.pickTimeslot"),
    orderAsGroupCTA: i18next.t("createGroupOrder.orderAsGroupCTA"),
    orderTogetherTitle: i18next.t("createGroupOrder.orderTogetherTitle"),
    orderTogetherSubtitle: i18next.t("createGroupOrder.orderTogetherSubtitle"),
    orderTogetherDisclaimer: i18next.t(
        "createGroupOrder.orderTogetherDisclaimer"
    ),
    linkTitle: i18next.t("createGroupOrder.linkTitle"),
    linkSubtitle: i18next.t("createGroupOrder.linkSubtitle"),
    groupOrderTip: i18next.t("createGroupOrder.groupOrderTip"),
    orderTill: i18next.t("createGroupOrder.orderTill"),
    groupOrderWarning: i18next.t("createGroupOrder.groupOrderWarning"),
    finish: i18next.t("createGroupOrder.finish"),
    qrcode: i18next.t("createGroupOrder.qrcode"),
    linkCopied: i18next.t("createGroupOrder.linkCopied"),
    shareLink: i18next.t("createGroupOrder.shareLink"),
    pickEarliest: i18next.t("createGroupOrder.pickEarliest"),
    abort: i18next.t("popup.close"),
};
